<template>
  <form-section
    id="consultant"
    :headline="this.$t('form.parties.supplier.headline')"
  >
    <textfield
      id="consultant_name"
      :label="$t('form.parties.supplier.name.label')"
      :placeholder="$t('form.parties.supplier.name.placeholder')"
      v-model="supplier.name"
      isRequired
      v-on:focus="scrollTo('#parties')"
    />

    <textfield
      id="supplier_address"
      :label="$t('form.parties.supplier.address.label')"
      :placeholder="$t('form.parties.supplier.address.placeholder')"
      v-model="supplier.address"
      isRequired
      v-on:focus="scrollTo('#parties')"
    />

    <div class="form-group">
      <label for="supplier_cvr">{{
        $t("form.parties.supplier.cvr.label")
      }}</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="supplier_cvr"
          maxlength="8"
          minlength="8"
          :placeholder="$t('form.parties.supplier.cvr.placeholder')"
          v-model="supplier.cvr"
          @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
          @blur="validateRequired"
          required
          v-on:focus="scrollTo('#parties')"
        />
        <div class="invalid-feedback">
          <invalid-cross></invalid-cross>
          <span>{{ $t("form.shared.cvr_error") }}</span>
        </div>
      </div>
    </div>
  </form-section>
</template>

<script>
import Textfield from "@/shared/components/Textfield.vue";
import FormSection from "@/shared/components/FormSection.vue";
export default {
  components: {
    Textfield,
    FormSection,
  },
  data() {
    return {
      supplier: {
        name: "",
        cvr: "",
        address: "",
      },
    };
  },
  watch: {
    supplier: {
      handler() {
        this.supplier.cvr = this.restrictNumber(this.supplier.cvr);
        this.$store.commit("updateSupplier", this.supplier);
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/form/parties/SupplierInput.vue